import { createReducer, on } from '@ngrx/store';
import { initialMobileState } from './mobile-state';
import { mobileEnter, mobileLeave, mobileUpdate } from './mobile-actions-creator';

export const mobileReducer = createReducer(
  initialMobileState,
  on(mobileEnter, (state) => ({...state, isMobile: false})),
  on(mobileLeave, (state) => ({...state, isMobile: false})),
  on(mobileUpdate, (_state, action) => (action.payload))
);
